import { render, staticRenderFns } from "./ChallengesExcursions.vue?vue&type=template&id=56a43e62&"
import script from "./ChallengesExcursions.vue?vue&type=script&lang=js&"
export * from "./ChallengesExcursions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports